import {
  pgTable,
  uuid,
  text,
  integer,
  timestamp,
  jsonb,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

// ---------------------------------------------------------------------------
// Status enum
// ---------------------------------------------------------------------------

export const PAYMENT_STATUSES = [
  "pending",
  "completed",
  "failed",
  "refunded",
  "partially_refunded",
] as const;

export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

// ---------------------------------------------------------------------------
// Timestamp helper
// ---------------------------------------------------------------------------

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// payment_transactions
// ---------------------------------------------------------------------------

export const paymentTransactions = pgTable(
  "payment_transactions",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    stripeAccountId: text("stripe_account_id"),
    stripePaymentId: text("stripe_payment_id"),
    stripeEventId: text("stripe_event_id"), // webhook dedup
    amountCents: integer("amount_cents").notNull(),
    currencyCode: text("currency_code").default("eur").notNull(),
    surchargeCents: integer("surcharge_cents").default(0).notNull(),
    platformFeeCents: integer("platform_fee_cents").default(0).notNull(),
    netAmountCents: integer("net_amount_cents").notNull(),
    surchargeBreakdown: jsonb("surcharge_breakdown"), // [{orgId, orgName, amount, model, rate}]
    status: text("status").default("pending").notNull(),
    refundAmountCents: integer("refund_amount_cents").default(0).notNull(),
    refundStatus: text("refund_status"), // null, pending, completed
    customerId: text("customer_id"), // Stripe customer ID
    description: text("description"),
    metadata: jsonb("metadata").default({}).notNull(),
    createdAt: timestamp("created_at", tz).defaultNow().notNull(),
    processedAt: timestamp("processed_at", tz),
  },
  (table) => [
    uniqueIndex("uq_payment_stripe_event").on(table.stripeEventId).where(sql`stripe_event_id IS NOT NULL`),
    index("idx_payment_tenant").on(table.tenantId),
    index("idx_payment_status").on(table.tenantId, table.status),
    index("idx_payment_stripe_payment").on(table.stripePaymentId),
  ],
);
